// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: 'v723demo1',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: false,
  apiUrl: 'api',
  /*URL_BACKEND: 'https://api.plocesaelite.com/',
  URL_SERVICIOS: 'https://api.plocesaelite.com/api',
  URL_FROTEND: 'https://admin.plocesaelite.com',*/
  //URL_BACKEND: 'http://localhost:9090/',
  //URL_SERVICIOS: 'http://localhost:9090/api',
  //URL_FROTEND: 'http://localhost',
  URL_BACKEND: 'https://gironthing.cloud/apiPlocesa/',
  URL_SERVICIOS: 'https://gironthing.cloud/apiPlocesa/api',
  URL_FROTEND: 'https://adminplocesa.gironthing.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
